import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  image: { width: '60px', height: '50px' },
  imageSmall: { width: '30px', height: '25px' },
}));

type Props = {
  fileName: string;
  isFolder: boolean;
  small?: boolean;
};

export default function DocumentTypeImage({ fileName, isFolder, small }: Props) {
  const classes = useStyles();
  const imageClass = small ? classes.imageSmall : classes.image;
  const ext = fileName.split('.');
  if (isFolder) {
    switch (ext[0]) {
      case 'Basic Information':
        return (
          <img className={imageClass} src="/icons/basic-information.svg" alt="basic-information" />
        );
      case 'Relationships':
        return <img className={imageClass} src="/icons/relationships.svg" alt="relationships" />;
      case 'Health Care':
        return <img className={imageClass} src="/icons/healthcare.svg" alt="Health Care" />;
      case 'Receipts':
        return <img className={imageClass} src="/icons/receipts.svg" alt="Receipts" />;
      case 'Tax Preparation':
        return <img className={imageClass} src="/icons/tax-prep.svg" alt="Tax Preparation" />;
      case 'Tax Returns':
        return <img className={imageClass} src="/icons/tax-returns.svg" alt="Tax Returns" />;
      case 'Liabilities':
        return <img className={imageClass} src="/icons/liabilities.svg" alt="liabilities" />;
      case 'Accounts':
        return <img className={imageClass} src="/icons/accounts.svg" alt="accounts" />;
      case 'Real Property':
        return <img className={imageClass} src="/icons/real-property.svg" alt="real-property" />;
      case 'Special Property':
        return (
          <img className={imageClass} src="/icons/special-property.svg" alt="special-property" />
        );
      case 'Personal Property':
        return (
          <img className={imageClass} src="/icons/personal-property.svg" alt="personal-property" />
        );
      case 'Often Overlooked':
        return (
          <img className={imageClass} src="/icons/often-overlooked.svg" alt="often-overlooked" />
        );
      case 'Planning':
        return <img className={imageClass} src="/icons/planning.svg" alt="planning" />;
      case 'Retirement & Benefits':
        return (
          <img
            className={imageClass}
            src="/icons/retirement-benefits.svg"
            alt="retirement-benefits"
          />
        );
      default:
        return <img className={imageClass} src="/icons/folder-icon.svg" alt="Folder" />;
    }
  }

  switch (ext[1]) {
    case 'docx':
      return <img className={imageClass} src="/icons/doc.svg" alt="doc" />;
    case 'xls':
    case 'xlsx':
      return <img className={imageClass} src="/icons/xls.svg" alt="xls" />;
    case 'jpg':
      return <img className={imageClass} src="/icons/jpg.svg" alt="jpg" />;
    case 'png':
      return <img className={imageClass} src="/icons/png.svg" alt="png" />;
    case 'pdf':
      return <img className={imageClass} src="/icons/pdf.svg" alt="pdf" />;
    case 'txt':
      return <img className={imageClass} src="/icons/txt.svg" alt="txt" />;
    case 'zip':
      return <img className={imageClass} src="/icons/zip.svg" alt="txt" />;
    default:
      return <img className={imageClass} src="/icons/unkown.svg" alt="misc" />;
  }
}
